import React from 'react';
import ReportViewer from "./base/ReportViewer";

const ListeArriveeDepart = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"Listearriveedepartreport"} />
        </div>
    );
}
export default ListeArriveeDepart;